import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import OneSquare from './components/OneSquare';
const TwoSquares = t0 => {
  const $ = _c(11);
  const {
    config: t1
  } = t0;
  const {
    squareBlock1: t2,
    squareBlock2: t3
  } = t1;
  let t4;
  if ($[0] !== t2) {
    t4 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const squareBlock1 = t4;
  let t5;
  if ($[2] !== t3) {
    t5 = t3 === undefined ? {} : t3;
    $[2] = t3;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const squareBlock2 = t5;
  let t6;
  if ($[4] !== squareBlock1) {
    t6 = <OneSquare config={squareBlock1} />;
    $[4] = squareBlock1;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== squareBlock2) {
    t7 = <OneSquare config={squareBlock2} />;
    $[6] = squareBlock2;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = <FixedWidthContainer className="min-h-[500px] flex flex-col md:flex-row" noMobilePadding={true} noTabletPadding={true}>{t6}{t7}</FixedWidthContainer>;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
};
TwoSquares.propTypes = {
  config: PropTypes.shape({
    squareBlock1: OneSquare.propTypes.config,
    squareBlock2: OneSquare.propTypes.config
  })
};
export default TwoSquares;